import type React from 'react'
import { useState, useRef, useEffect } from 'react'
import styled from 'styled-components'

interface Props {
  label: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  value: string
}

const TextInputContainer = styled.div`
  margin: 10px 0;
  padding: 18px;
  position: relative;
  text-align: left;
  cursor: text;
  border: none;
  border-bottom: 1px solid #f2f2f2;
`

const TextInputElement = styled.input`
  margin-left: 25px;
  width: 100%;
  outline: none;
  border: none;
  background: none;
`

const TextInputLabel = styled.span<{ focused: boolean }>`
  margin-left: 25px;
  position: absolute;
  color: ${props => (props.focused ? '#34bebd' : '#bcbec0')};
  transform: ${props => (props.focused ? 'translateY(-29px) scale(0.71)' : '')};
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  cursor: text;
  white-space: nowrap;
  font-size: 14px;
  background: ${props => (props.focused ? 'white' : 'transparent')};
  padding: 2px 8px;
`

const SearchIcon = styled.img`
  position: absolute;
  left: 0;
  top: 10px;
`

const SearchInput: React.FC<Props> = ({ label, onChange, value }) => {
  const [focused, setFocused] = useState(false)
  const inputRef = useRef<HTMLInputElement>(document.createElement('input'))

  function handleBlur() {
    if (inputRef.current.value.trim() === '') {
      setFocused(false)
    } else {
      setFocused(true)
    }
  }

  function handleFocus() {
    // @ts-ignore
    inputRef.current.focus()
    setFocused(true)
  }

  useEffect(() => {
    //@ts-ignore
    if (inputRef.current.value.trim() !== '') {
      setFocused(true)
    }
  }, [value])

  return (
    <TextInputContainer onClick={() => handleFocus()}>
      <TextInputLabel
        focused={focused}
        id="text-input"
        onClick={() => setFocused(true)}
        onBlur={() => handleBlur()}
      >
        {label}
      </TextInputLabel>
      <SearchIcon src="/assets/svg/search-icon.svg" />
      <TextInputElement
        type="text"
        value={value}
        ref={inputRef}
        onClick={() => setFocused(true)}
        onBlur={() => handleBlur()}
        onChange={onChange}
        autoComplete="off"
      />
    </TextInputContainer>
  )
}

export default SearchInput
